import posthog from 'posthog-js';

import { env } from './env';
import { medplum } from './medplum';

const apiKey = env.VITE_PUBLIC_POSTHOG_KEY;

if (apiKey) {
  posthog.init(apiKey, {
    api_host: env.VITE_PUBLIC_POSTHOG_HOST,
    capture_exceptions: true,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    disable_session_recording: true,
    capture_heatmaps: false,
    capture_performance: { web_vitals: false, network_timing: false },
    __add_tracing_headers: [window.location.origin],
    loaded: (ph) => {
      ph.register({
        app_env: env.VITE_APP_ENV,
        release: import.meta.env.VITE_RELEASE_SHA ?? 'unknown',
      });
    },
  });

  const syncIdentity = () => {
    const profile = medplum.getProfile();
    if (profile?.id && profile.resourceType) {
      posthog.identify(`${profile.resourceType}/${profile.id}`, {
        resourceType: profile.resourceType,
      });
    } else {
      posthog.reset();
    }
  };

  medplum.addEventListener('change', syncIdentity);
  syncIdentity();
}

export { posthog };
